// extracted by mini-css-extract-plugin
export default {"hidden":"nIdRs3ZGHeuGOhE5XEGi"};